var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[(!_vm.from_temas)?_c('checkbox-selector-vue',{attrs:{"checkboxList":_vm.ambitos_filter,"field":_vm.checkboxFieldName},on:{"checkbox:clicked":_vm.handleCheckboxEmmit}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }